import gql from 'graphql-tag';

export const AppListingFragmentCommon = gql`
    fragment AppListingFragmentCommon on AppListing {
        id
        creationDate
        language
        name
        tagLine
        description
        searchTerms
        integrations
        promoVideoUrl
        includeKeyBenefitsImages
        supportEmail
        supportPhone
        websiteUrl
        privacyPolicyUrl
        termsOfServiceUrl
        icon {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
        }
        screenShots {
            type
            description
            image {
                s3Key
                fileName
                fileType
                height
                width
                size
                sourceUrl
            }
        }
        keyBenefits {
            title
            description
            image {
                s3Key
                fileName
                fileType
                height
                width
                size
                sourceUrl
            }
        }
        pricePlans {
            planId
            name
            features
        }
    }
`;

export const AppFragmentCommon = gql`
    ${AppListingFragmentCommon}
    fragment AppFragmentCommon on App {
        id
        name
        creationDate
        status
        type
        apiContactEmail
        apiCredentials {
            apiKey
            secretKey
        }
        numberOfInstallations
        linkedVendor {
            id
            name
        }
        appUrl
        redirectUrlWhitelist
        chargeType
        installationCountries
        oneTimeChargeAmount
        freeTrialDays
        appReviewInstructions
        pricePlans {
            id
            creationDate
            name
            type
            discountedYearlyPrice
            monthlyAmount
            yearlyAmount
        }
        listings {
            id
            ...AppListingFragment
        }
    }
`;

export const PayoutSettingsFragment = gql`
    fragment PayoutSettingsCommon on PayoutSettingsType {
        abaRouting
        bankAccountNumber
        bankId
        bankName
        branchId
        currencyCode
        iban
        payableTo
        paymentTerms
        paymentType
        payoutContactEmail
        payoutContactPhoneNumber
        swift
        usResident
    }
`;
